import actionTypes from 'src/js/modules/context-menu/constants/action-types';

const hideContextMenu = () => ({
  type: actionTypes.HIDE_CONTEXT_MENU,
});

export default hideContextMenu;
